import { render, staticRenderFns } from "./mobileClient.vue?vue&type=template&id=712a4ec7&scoped=true&"
import script from "./mobileClient.vue?vue&type=script&lang=js&"
export * from "./mobileClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a4ec7",
  null
  
)

export default component.exports